import { render, staticRenderFns } from "./WaitingModal.vue?vue&type=template&id=c0b26886&scoped=true&"
import script from "./WaitingModal.vue?vue&type=script&lang=js&"
export * from "./WaitingModal.vue?vue&type=script&lang=js&"
import style0 from "./WaitingModal.vue?vue&type=style&index=0&id=c0b26886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b26886",
  null
  
)

export default component.exports